import React from "react";
import { CommunityTitle } from "../../../../components/community/community-title";
import { PAST_READING_PLANS } from "../../../data/reading-plans";
import { useTranslations } from "../../../../hooks/use-translations";
import _ from "lodash";
import { useLanguage } from "../../../../hooks/use-language";

export const PastReadingPlans = () => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "comunidad_club", lang: lang });
	const pastPlans = [...PAST_READING_PLANS];

	return (
		<div className="container">
			<div className="mt-5 mb-4">
				<CommunityTitle.H4 title={_.get(texts, 'planes.planes_pasados.titulo') || "Planes de lectura pasados"} />
			</div>
			<ul className="row justify-content-center align-items-center p-0 m-0">
				{pastPlans?.map((plan, i) => {
					return (
						/* <div
							key={plan?.id}
							className="col-auto col-md m-2 p-2 d-flex justify-content-center align-items-center"
						> */
						<li
							key={plan?.id}
							className="col-3 col-md px-1 mb-3 mb-lg-0 d-flex justify-content-center align-items-center"
						//className="m-2 p-0 past-reading-plan-card"
						>
							<a
								className="w-100 focusable-red primary-button-var2"
								href={`${plan?.file?.[lang] || plan?.file?.es}`}
								aria-label={`plan-${plan?.id}`}
								target="_blank"
								rel="noopener noreferrer"
								download={true}
								style={{padding: 11}}
							>
								{plan?.name?.default || "N/A"}
								{/* <img
										className="img img-fluid"
										src={plan?.img}
										alt={`${plan?.id}`}
									/> */}
							</a>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
